import RenderHTML from '../../ui-components/RenderHTML'
import { InvestPaymentMethodType } from '../../../types/mf-execution.types'
import { getBankLogoSrc } from '../../../utils/mf-execution/paymentMethodsScreenUtils'
import { upiLinkedBankChevronDownIcon } from './icons/paymentMethodIcons'

export type UpiLinkedBankDetailsProps = {
  bankAccounts: InvestPaymentMethodType[]
  selectedBankAccount: InvestPaymentMethodType | null
  onSelectBankClick?: () => void
  isAutopay?: boolean
}

/** Shows the bank account linked to the selected UPI app and opens bank picker when multiple exist. */
export function UpiLinkedBankDetails({
  bankAccounts,
  selectedBankAccount,
  onSelectBankClick,
  isAutopay = false,
}: UpiLinkedBankDetailsProps) {
  const displayBankAccount = selectedBankAccount ?? bankAccounts[0] ?? null

  if (!displayBankAccount?.displayAccNumber) return null

  const showChevron = bankAccounts.length > 1

  return (
    <div className='mt-4 pl-[60px]'>
      <div
        className={`flex items-center gap-2 border border-grey60 rounded-xl px-4 py-3 ${onSelectBankClick ? 'cursor-pointer' : ''}`}
        onClick={onSelectBankClick}
      >
        <img
          src={getBankLogoSrc(displayBankAccount?.logoUrl)}
          alt={displayBankAccount?.displayAccNumber ?? ''}
          className='w-4 h-4 object-contain flex-shrink-0'
          onError={(event) => {
            event.currentTarget.src = '/images/mutual_fund/categories/banks_grayscale.svg'
          }}
        />
        <p className='text-sm font-medium text-grey10 truncate flex-1 min-w-0'>
          {displayBankAccount?.displayAccNumber ?? ''}
        </p>
        {showChevron ? (
          <div className='flex-shrink-0 ml-1'>
            <RenderHTML innerHTMLText={upiLinkedBankChevronDownIcon} />
          </div>
        ) : null}
      </div>
      <p className='text-xs text-grey40 mt-3'>
        {isAutopay
          ? 'Use the same bank account after redirecting to UPI app to avoid autopay setup failure'
          : 'Pay using the selected bank to avoid order cancellation'}
      </p>
    </div>
  )
}
